import React, { FC } from 'react';
import { Col, Container, FormLabel, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import styles from '../../../components/modalRegisterMessageTrigger/styles';
import { AttachmentsInMessageProps } from './indexModel';

const AttachmentsInMessage: FC<AttachmentsInMessageProps> = (props) => {
    const showFiles = props.files.map((file, index) => (
        <span key={file.name + index}
          style={{
            background: '#E8E8E8 0% 0% no-repeat padding-box',
            borderRadius: '3px',
            opacity: '1',
            marginRight: '0.5vw',
            marginBottom: '1vh',
            whiteSpace: 'pre', display: 'inline-block',
          }}>
          <svg id="Grupo_11419" data-name="Grupo 11419" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Caminho_9725" data-name="Caminho 9725" d="M0,0H24V24H0Z" fill="none" />
            <path id="Caminho_9726" data-name="Caminho 9726" d="M14,3V7a1,1,0,0,0,1,1h4" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path id="Caminho_9727" data-name="Caminho 9727" d="M17,21H7a2,2,0,0,1-2-2V5A2,2,0,0,1,7,3h7l5,5V19A2,2,0,0,1,17,21Z" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <line id="Linha_391" data-name="Linha 391" y2="6" transform="translate(12 11)" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path id="Caminho_9728" data-name="Caminho 9728" d="M9,14l3-3,3,3" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
          </svg>
          <span
            onClick={ (e) => { e.stopPropagation(); props.handleDownloadFile(file); }}
            style={{
              textAlign: 'left',
              font: 'var(--px10_13-font-Roboto)',
              letterSpacing: '0px',
              color: '#1E1E1E',
              opacity: '1',
              // maxWidth: '70%'
            }}
            // className='oneLineClampEllipsis'
          >
            <span 
              style={{  }}
            >
              {file.name}
            </span>
          </span>
          { props.fileLoading[index] === false ? file.isLoading = false : "" }
          {!props.fileLoading[index] ?
            <svg name={file.name} onClick={(e) => { props.deleteFile(file.name); e.stopPropagation(); } } style={{ cursor: 'pointer', marginRight: '3px', marginLeft: '3px' }} id="Grupo_11428" data-name="Grupo 11428" xmlns="http://www.w3.org/2000/svg" width="14.438" height="14.438" viewBox="0 0 14.438 14.438">
              <path id="Caminho_9729" data-name="Caminho 9729" d="M0,0H14.438V14.438H0Z" fill="none" />
              <line id="Linha_392" data-name="Linha 392" x1="7" y2="7" transform="translate(4 3.438)" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
              <line id="Linha_393" data-name="Linha 393" x2="7" y2="7" transform="translate(4 3.438)" fill="none" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            </svg>
            :
            <Spinner animation="border" role="status" style={{ marginRight: '3px', marginLeft: '3px', width: "14.438px", height: "14.438px" }} >
            </Spinner>
          }
        </span>
      ));

    return (
        <Container>
            <Row className={(props.customTitle && props.customDropMessage? "": "mb-3") + " d-flex justify-content-center"} style={styles.textFontGlay}>
                <Col /* sm={true} */>
                  <FormLabel htmlFor='basic-url'>
                    {props.t("home_message_trigger.list_of_trigger_types.attachments")}
                    <OverlayTrigger
                      key='top'
                      placement='top'
                      overlay={
                        <Tooltip id='tooltip'>
                          <span style={{ display: 'flex', justifyContent: "flex-start", fontWeight: "bold" }}>{props.t('home_tickets.chat_editor.channel_info_title')}</span><br/>
                          <span style={{ display: 'flex', justifyContent: "flex-start" }}>{props.t('home_tickets.chat_editor.channel_info_max')} 25 Mb</span><br/>
                          {/* <span style={{ display: 'flex', justifyContent: "flex-start" }}>{props.t('home_tickets.chat_editor.channel_type')} {props.t('home_tickets.chat_editor.all')}</span><br/> */}
                        </Tooltip>
                      }
                    >
                      <svg id="informação" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="mx-1">
                          <path id="Caminho_10010" data-name="Caminho 10010" d="M0,0H24V24H0Z" fill="none" />
                          <circle id="Elipse_1556" data-name="Elipse 1556" cx="9" cy="9" r="9" transform="translate(3 3)" fill="none" stroke="#1e1e1e" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                          <line id="Linha_604" data-name="Linha 604" x2="0.01" transform="translate(12 8)" fill="none" stroke="#1e1e1e" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                          <path id="Caminho_10011" data-name="Caminho 10011" d="M11,12h1v4h1" fill="none" stroke="#1e1e1e" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                      </svg>
                    </OverlayTrigger>
                  </FormLabel>
                  <div style={{width: '100%', display: 'flex', overflowY: 'hidden'}}>
                    <div {...props.getRootProps({ className: 'dropzone' })} style={styles.dragDropzone}>
                      <input style={{backgroundColor: 'red'}} {...props.getInputProps({})} />
                      {props.files.length > 0 ?
                        <div name="showFilesAttachments" style={{ overflowY: 'auto', maxHeight: '8vh' }} className="ps-2 py-1 pt-2">
                            <div style={{ display: 'block' }}>
                              {showFiles}
                          </div>
                        </div>
                        :
                        <div>
                          <div>{props.selectedChannelId ? props.t("home_message_trigger.list_of_messages_triggers.message_file") : props.t("home_message_trigger.list_of_messages_triggers.no_channel")}</div>
                        </div>
                      }
                    </div>
                  </div>
                </Col>
            </Row>
        </Container>
    );
}

export default AttachmentsInMessage;